import React from 'react';
import { useSelector } from 'react-redux';

const SingleDatePicker = ({
	type,
	onChangeHandler,
	onApplyHandler,
	inputValue,
	placeHolderOne = 'Min',
	onClearInputFields,
	inputType = 'number'
}) => {
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const today = new Date().toISOString().split('T')[0];
	return (
		<>
			{selectedField?.selectedCheckboxField === type && (
				<div className="filter-submenu scroll-y-label">
					<div className="card border-0">
						<div className="card-body">
							<div className="col-md-12 p-0">
								<div className="form-group mb-2">
									<input
										type={inputType}
										placeholder={placeHolderOne}
										name="date"
										value={inputValue || ''}
										onChange={onChangeHandler}
										autoFocus={false}
										max={today}
									/>
								</div>
							</div>
							<div className="d-flex justify-content-end mt-3">
								<button className="button outline mr-2" onClick={onClearInputFields}>
									Cancel
								</button>
								<button
									className="button"
									onClick={() => {
										onApplyHandler();
										// onOutSideClick();
									}}
								>
									Apply
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default SingleDatePicker;
